import React from "react";
import { Modal, Stack, Text, Group, Button } from "@mantine/core";
import { IconCheck, IconX } from "@tabler/icons-react";

type Props = {
  opened: boolean;
  onClose: () => void;
  onRespond: (response: "accepted" | "declined") => void;
  title?: string;
};

export default function RespondToInvitationModal({
  opened,
  onClose,
  onRespond,
  title = "Respond to Meeting Invitation",
}: Props) {
  return (
    <Modal opened={opened} onClose={onClose} title={title} size="xs">
      <Stack align="center">
        <Text color="dimmed">Please respond to the meeting invitation:</Text>
        <Group>
          <Button
            onClick={() => {
              onRespond("accepted");
            }}
            leftIcon={<IconCheck />}
          >
            Accept
          </Button>

          <Button
            color="red"
            onClick={() => {
              onRespond("declined");
            }}
            leftIcon={<IconX />}
          >
            Decline
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
